export default "__VITE_ASSET__CqAhuhaa__"